module.exports = __webpack_public_path__ + "70baae7c6303ed43bf685b86d012a066.pdf";